import React, { useState } from 'react'
import { Box, Container, Grid, Typography, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import opencell from '../assets/images/opencell.png'

const StyledTitle = styled(Typography)(({ theme }) => ({
  color: '#FF0000',
  marginBottom: theme.spacing(1),
}))

const StyledSubtitle = styled(Typography)(({ theme }) => ({
  color: '#000',
  marginBottom: theme.spacing(3),
}))

const CarouselContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  minHeight: 600,
  overflow: 'hidden', // Add this to prevent image overflow during transition
  [theme.breakpoints.down('md')]: {
    minHeight: 300,
  },
}))

const CarouselImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute', // Add absolute positioning
  top: 0,
  left: 0,
  transition: 'opacity 0.3s ease-in-out', // Add smooth transition
  opacity: 0, // Hide by default
  '&.active': {
    opacity: 1, // Show when active
  },
})

const CarouselButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
}))

const CarouselDots = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: theme.spacing(1),
}))

const CarouselDot = styled(Box)(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: 'rgba(255, 255, 255, 1)',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease-in-out', // Add smooth transition for dots
  '&.active': {
    backgroundColor: 'rgba(244, 152, 13, 0.93)',
  },
}))

export default function OpenCellAssemblyPage() {
  const [activeSlide, setActiveSlide] = useState(0)

  const images = [
   opencell
  ]

  const handlePrevious = () => {
    setActiveSlide((prev) => (prev === 0 ? images.length - 1 : prev - 1))
  }

  const handleNext = () => {
    setActiveSlide((prev) => (prev === images.length - 1 ? 0 : prev + 1))
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <br/>
      <Grid container spacing={4}>
        <Grid item xs={12} md={5}>
          <StyledSubtitle variant="h3" component="h2">
          TABLETS
          </StyledSubtitle>
          <Typography variant="body1" sx={{ mb: 3 }}>
          Expanding our capabilities, we work closely with a diverse range of brands to introduce cutting-edge technology and innovative solutions within our tablet and PC vertical. By leveraging the latest advancements and trends, we aim to meet the ever-growing demands of the tech industry.

Our team of experts focuses on precision manufacturing, combining advanced techniques with attention to detail to ensure the highest quality standards. This commitment to excellence allows us to consistently deliver products that provide an exceptional customer experience, reinforcing our position as a trusted partner in the technology sector.





          </Typography>
        
        </Grid>
        <Grid item xs={12} md={7}>
          <CarouselContainer>
            {images.map((image, index) => (
              <CarouselImage
                key={index}
                src={image}
                alt={`Slide ${index + 1}`}
                className={index === activeSlide ? 'active' : ''}
              />
            ))}
           
          </CarouselContainer>
        </Grid>
      </Grid>
    </Container>
  )
}
